<div [class]="'login-image' + ' ' + (cssClass() ?? '')">
  <div class="gradient-overlay"></div>
  <div class="bubbles">
    @for (bubble of bubbleImages(); track bubble.bubbleIndex) {
      <span
        [class.bubble-active]="true"
        [class.has-image]="bubble.url"
        [class.image-visible]="bubble.visible && !bubble.fading"
        [class.image-fading]="bubble.fading"
      >
        @if (bubble.url) {
          <img [src]="bubble.url" [alt]="'Profile preview'" />
        }
      </span>
    }
  </div>

  <div class="image-content">
    <div class="brand-logo" style="cursor: pointer;" (click)="goHome()">
      <div class="icon-tile">
        <img src="assets/favicon/ptbd-favicon.png" alt="Adore The Balloon Logo" />
      </div>
    </div>
    <h2 class="welcome-text">{{ welcomeText() }}</h2>
    <div class="welcome-subtitle">{{ welcomeSubtitle() }}</div>
  </div>
  <div class="footer-divider"></div>
  <div class="left-footer">
    © {{ year() }} Adore The Balloon. &nbsp;
    <a [href]="insizonUrl">All rights reserved.</a>
  </div>
</div>